<template>
  <div class="shell-nav container">
    <div class="shell-nav__bar">
      <div class="shell-nav__brand">
        <div class="shell-nav__logo-wrap">
          <img v-if="logoPath" :src="logoPath" alt="logo" class="shell-nav__logo" />
          <img v-else src="@/assets/portal-mark.svg" alt="Portal" class="shell-nav__mark" />
        </div>
        <div class="shell-nav__brand-copy d-none d-sm-block">
          <div class="shell-nav__product">{{ $t("pages.login.description") }}</div>
        </div>
      </div>

      <nav class="shell-nav__links d-none d-lg-flex" aria-label="Main">
        <ul class="nav shell-nav__menu">
          <li class="nav-item main-bottom-menu-item">
            <router-link :to="{ name: 'dashboard' }" class="nav-link" exact>
              <i class="fas fa-home" aria-hidden="true"></i>
              {{ $t("pages.dashboard.title") }}
            </router-link>
          </li>
          <template v-if="isCurrentRoleEmployee">
            <li class="nav-item main-bottom-menu-item" v-if="activeEmployeePayrolls">
              <router-link :to="{ name: 'payroll' }" class="nav-link">
                <i class="fas fa-file-invoice-dollar" aria-hidden="true"></i>
                {{ $t("pages.payroll.title") }}
              </router-link>
            </li>
            <li class="nav-item main-bottom-menu-item" v-if="activeEmployeePermissions">
              <router-link :to="{ name: 'permission' }" class="nav-link">
                <i class="fas fa-clipboard-list" aria-hidden="true"></i>
                {{ $t("pages.permission.title") }}
              </router-link>
            </li>
            <li class="nav-item main-bottom-menu-item" v-if="activeEmployeePlanning">
              <router-link :to="{ name: 'planning' }" class="nav-link">
                <i class="fas fa-calendar-week" aria-hidden="true"></i>
                {{ $t("pages.planning.title") }}
              </router-link>
            </li>
            <li class="nav-item main-bottom-menu-item" v-if="showNethinkingTraining">
              <a
                href="#"
                class="nav-link"
                :class="{ disabled: openingTraining }"
                :aria-busy="openingTraining ? 'true' : 'false'"
                :aria-disabled="openingTraining ? 'true' : 'false'"
                @click.prevent="openTraining"
              >
                <span
                  v-if="openingTraining"
                  class="spinner-border spinner-border-sm mr-1"
                  role="status"
                  aria-hidden="true"
                ></span>
                <i v-else class="fas fa-graduation-cap" aria-hidden="true"></i>
                {{ $t("pages.navigation.training") }}
              </a>
            </li>
          </template>
          <template v-else>
            <li class="nav-item main-bottom-menu-item">
              <router-link :to="{ name: 'payroll-employees' }" class="nav-link">
                <i class="fas fa-file-invoice-dollar" aria-hidden="true"></i>
                {{ $t("pages.payroll-employees.title") }}
              </router-link>
            </li>
            <li class="nav-item main-bottom-menu-item">
              <router-link :to="{ name: 'planing-team' }" class="nav-link">
                <i class="fas fa-users" aria-hidden="true"></i>
                {{ $t("pages.planing-team.title") }}
              </router-link>
            </li>
          </template>
        </ul>
      </nav>

      <div class="shell-nav__actions">
        <div class="shell-nav__notify">
          <notification-component />
        </div>
        <theme-toggle-component />
        <profile-user-menu></profile-user-menu>
        <a class="shell-nav__logout" href="#" @click.prevent="logout">
          <i class="fas fa-sign-out-alt"></i>
          <span class="d-none d-xl-inline">{{ $t("pages.navigation.sign_out") }}</span>
        </a>
      </div>
    </div>

    <nav class="shell-nav__links shell-nav__links--mobile d-lg-none" aria-label="Main mobile">
      <ul class="nav shell-nav__menu">
        <li class="nav-item main-bottom-menu-item">
          <router-link :to="{ name: 'dashboard' }" class="nav-link" exact>
            <i class="fas fa-home" aria-hidden="true"></i>
            {{ $t("pages.dashboard.title") }}
          </router-link>
        </li>
        <template v-if="isCurrentRoleEmployee">
          <li class="nav-item main-bottom-menu-item" v-if="activeEmployeePayrolls">
            <router-link :to="{ name: 'payroll' }" class="nav-link">
              <i class="fas fa-file-invoice-dollar" aria-hidden="true"></i>
              {{ $t("pages.payroll.title") }}
            </router-link>
          </li>
          <li class="nav-item main-bottom-menu-item" v-if="activeEmployeePermissions">
            <router-link :to="{ name: 'permission' }" class="nav-link">
              <i class="fas fa-clipboard-list" aria-hidden="true"></i>
              {{ $t("pages.permission.title") }}
            </router-link>
          </li>
          <li class="nav-item main-bottom-menu-item" v-if="activeEmployeePlanning">
            <router-link :to="{ name: 'planning' }" class="nav-link">
              <i class="fas fa-calendar-week" aria-hidden="true"></i>
              {{ $t("pages.planning.title") }}
            </router-link>
          </li>
          <li class="nav-item main-bottom-menu-item" v-if="showNethinkingTraining">
            <a
              href="#"
              class="nav-link"
              :class="{ disabled: openingTraining }"
              :aria-busy="openingTraining ? 'true' : 'false'"
              :aria-disabled="openingTraining ? 'true' : 'false'"
              @click.prevent="openTraining"
            >
              <span
                v-if="openingTraining"
                class="spinner-border spinner-border-sm mr-1"
                role="status"
                aria-hidden="true"
              ></span>
              <i v-else class="fas fa-graduation-cap" aria-hidden="true"></i>
              {{ $t("pages.navigation.training") }}
            </a>
          </li>
        </template>
        <template v-else>
          <li class="nav-item main-bottom-menu-item">
            <router-link :to="{ name: 'payroll-employees' }" class="nav-link">
              <i class="fas fa-file-invoice-dollar" aria-hidden="true"></i>
              {{ $t("pages.payroll-employees.title") }}
            </router-link>
          </li>
          <li class="nav-item main-bottom-menu-item">
            <router-link :to="{ name: 'planing-team' }" class="nav-link">
              <i class="fas fa-users" aria-hidden="true"></i>
              {{ $t("pages.planing-team.title") }}
            </router-link>
          </li>
        </template>
      </ul>
    </nav>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ProfileUserMenu from "@/pages/components/ProfileUserMenu.vue";
import ThemeToggleComponent from "@/pages/components/ThemeToggleComponent.vue";
import { NotificationComponent } from "./notification";
import nethinkingApi from "@/api/nethinking";
import { startNethinkingSso } from "@/services/nethinkingSso";
import { ModalAlert } from "@/components/modal";

export default {
  name: "HeaderNavigationComponent",
  components: {
    ProfileUserMenu,
    NotificationComponent,
    ThemeToggleComponent,
  },
  data() {
    return {
      openingTraining: false,
    };
  },
  mounted() {
    $('[data-toggle="popover"]').popover();
  },
  computed: {
    ...mapGetters("auth", [
      "isCurrentRoleEmployee",
      "activeEmployeePayrolls",
      "activeEmployeePermissions",
      "activeEmployeePlanning",
      "logoPath",
      "isNethinkingTrainingEnabled",
    ]),
    showNethinkingTraining() {
      return this.isCurrentRoleEmployee && this.isNethinkingTrainingEnabled;
    },
  },
  methods: {
    ...mapActions("auth", ["removeUser"]),
    logout() {
      this.removeUser();
      window.location.reload();
    },
    async openTraining() {
      if (!this.showNethinkingTraining || this.openingTraining) return;

      this.openingTraining = true;
      try {
        await startNethinkingSso({
          createSsoToken: () => nethinkingApi.createSsoToken(),
        });
      } catch (error) {
        const status = error && error.response && error.response.status;
        if (status === 401) {
          // Habitual session expiry handling
          this.removeUser();
          window.location.reload();
          return;
        }
        ModalAlert.error({
          message: this.$t("pages.navigation.training_error"),
        });
      } finally {
        this.openingTraining = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.shell-nav {
  position: relative;
}

.shell-nav__bar {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  min-height: 72px;
  padding: 0.6rem 0;
}

.shell-nav__brand {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
}

.shell-nav__logo-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.shell-nav__logo {
  height: 36px;
  width: auto;
  object-fit: contain;
  display: block;
}

.shell-nav__mark {
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  border-radius: 12px;
  box-shadow: 0 6px 14px rgba(79, 70, 229, 0.25);
}

.shell-nav__product {
  color: var(--portal-text);
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.2;
}

.shell-nav__actions {
  display: flex;
  align-items: stretch;
  height: 44px;
  border: 1px solid var(--portal-border);
  border-radius: 12px;
  background: var(--portal-surface);
  box-shadow: var(--portal-shadow-sm);
  overflow: visible;

  > * {
    display: flex;
    align-items: center;
    height: 100%;
  }

  > * + * {
    border-left: 1px solid var(--portal-border);
  }

  > *:first-child {
    border-radius: 11px 0 0 11px;
  }

  > *:last-child {
    border-radius: 0 11px 11px 0;
  }

  ::v-deep .theme-toggle,
  ::v-deep .name-user--button {
    height: 100%;
    padding: 0 0.85rem;
    border: none;
    border-radius: 0;
    background: transparent;
    box-shadow: none;

    &:hover {
      background: var(--portal-surface-muted);
      box-shadow: none;
    }
  }

  ::v-deep .name-user--link {
    height: 100%;
    padding: 0 0.85rem;
    display: flex;
    align-items: center;
  }

  ::v-deep .popper {
    z-index: 1045;
  }
}

.shell-nav__logout {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  height: 100%;
  padding: 0 0.85rem;
  border: none;
  border-radius: 0;
  background: transparent;
  color: var(--portal-text-muted) !important;
  font-size: 0.8rem;
  font-weight: 600;
  text-decoration: none !important;
  transition: background 0.2s ease, color 0.2s ease;

  &:hover {
    background: var(--portal-surface-muted);
    color: var(--portal-text) !important;
  }

  &:focus {
    outline: 2px solid var(--portal-ring);
    outline-offset: -2px;
  }
}

.shell-nav__links {
  align-items: center;
}

.shell-nav__links--mobile {
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0 0 0.65rem;
  -webkit-overflow-scrolling: touch;
  border-top: 1px solid var(--portal-border);

  .shell-nav__menu {
    background: none;
    border: none;
    padding: 0;
    gap: 0.35rem;
  }
}

.shell-nav__menu {
  flex-wrap: nowrap;
  gap: 0.2rem;
  padding: 0.35rem;
  border: 1px solid var(--portal-primary-soft);
  border-radius: 999px;
  background: var(--portal-primary-soft);
}

.shell-nav__notify {
  display: inline-flex;
  align-items: center;
  height: 100%;

  ::v-deep .nav-link {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 0 0.85rem !important;
    border: none;
    border-radius: 0;
    background: transparent;
    color: var(--portal-text-muted) !important;
    transition: background 0.2s ease, color 0.2s ease;

    &:hover {
      background: var(--portal-surface-muted);
      color: var(--portal-text) !important;
    }

    .fa-bell {
      font-size: 0.95rem;
    }

    .notification-count {
      top: 4px !important;
      left: auto !important;
      right: 4px !important;
    }
  }
}
</style>
